// #571 — extension logs must never carry user data (login email, push payload, profile-pic response).
// Log presence only, mirroring the token redaction of #570/FE#713.

/** Presence-only summary of any value: logs THAT it exists, never what it holds. */
export const describePresence = (value: unknown): { present: boolean } => ({ present: value !== null && value !== undefined });

/** Presence-only summary of a push event: the FCM payload (`event.data`) is user-bound, so log only whether it exists. */
export const describePushEvent = (event: { data?: unknown } | null | undefined): { present: boolean; hasData: boolean } => ({
  present: event !== null && event !== undefined,
  hasData: event?.data !== null && event?.data !== undefined,
});
